import { Authenticator } from '@aws-amplify/ui-react';
import { ThemeProvider } from '@aws-amplify/ui-react';
import theme from './theme';  // Import the theme
import { Image } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    console.log("came here")
    navigate('/dashboard');
  };



    return (
      <div className="login-area">
        <div className="login-picture"></div>
        <div className="login-section">
          <ThemeProvider theme={theme}>
            <div className='login-image'>
              <Image
                alt="Virsat Logo"
                src="/virsatbluelogo.png"
              />
            </div>
            <Authenticator onSignIn={handleSignIn}>

              {({ signOut, user }) => (
                <>
                {navigate('/dashboard')}
              {/* <p className='user-detail'> Logged in as <span className='span-id'>{user && user.signInDetails ? ` ${user.signInDetails.loginId}`: ""}</span>      
            </p> 
                <button className='body-button' onClick={signOut}>Sign Out</button> */}
                </>
              )}
            </Authenticator>
          </ThemeProvider>
        </div>
      </div>
    );
  };
  
  export default Login;
  